import { AssetIndexName } from '@imcc/transport';
import { SearchTabState } from './search-tab-state';
import { SortOrder } from './sort-order/sort-order.enum';
import { ThumbnailSize } from './thumbnail-size';

export const initialState: SearchState = Object.freeze({
  indexName: AssetIndexName.IMAGE,
  isUpdating: false,
  lastUpdated: 0,
  queryString: '',
  thumbnailSize: ThumbnailSize.LARGE,
  tabs: {
    [AssetIndexName.GRAPHIC_SYMBOL]: new SearchTabState({
      sortTerm: 'name',
      order: SortOrder.ASC,
    }),
    [AssetIndexName.IMAGE]: new SearchTabState(),
    [AssetIndexName.PUBLICATION]: new SearchTabState({
      sortTerm: 'scoreAndDate',
      order: SortOrder.DESC,
    }),
    [AssetIndexName.STORE_COMMUNICATION]: new SearchTabState(),
  },
});

export class SearchState {
  indexName: AssetIndexName = AssetIndexName.IMAGE;

  isUpdating = false;

  lastUpdated = 0;

  queryString = '';

  tabs: { [key in AssetIndexName]: SearchTabState };

  thumbnailSize: ThumbnailSize = ThumbnailSize.LARGE;
}
